import { render, staticRenderFns } from "./main-app.vue?vue&type=template&id=49a9b9c2"
import script from "./main-app.vue?vue&type=script&lang=js"
export * from "./main-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports